export const tokenAlive = expiresIn => {
  if (!expiresIn) return false;
  else if (new Date() >= new Date(expiresIn)) return false;
  return true;
};
